// Environment variables with proper typing
export const BASE_URL: string = process.env.REACT_APP_API_URL || "";

export const RegexUUIDExp: RegExp =
  /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;

export const fallBackMailForBalanceNotif: string =
  process.env.REACT_APP_FALLBACK_MAILID || "";
